<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Vendedores da empresa {{empresa.name}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="$router.push({name: isAdministrador ? 'Empresa' : 'Dashboard'})">Voltar</b-button>
              <b-button @click="$router.push({name: 'EmpresaVendedorForm', query: {empresa: empresa._id}})">Novo</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <b-table striped hover :busy="loading" :items="vendedores" :fields="fieldsEmpresa"
            show-empty emptyText="Não há vendedores cadastrados para empresa.">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
            </div>
              <template slot="[master]" slot-scope="row">
                <i title="Usuário Master" class="fas fa-user-shield text-primary" v-if="row.item.role === 'VendedorMaster'"></i>
              </template>
              <template slot="[status]" slot-scope="row">
                <span :title="row.item.status" :class="{'green': row.item.status === 'Habilitado', 'orange': row.item.status === 'Desabilitado'}" class="status-pill smaller"></span><span></span>
              </template>
              <template slot="[actions]" slot-scope="row">
                <b-button variant="warning" size="sm"
                  @click="formVendedor(row.item)">
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button variant="success" size="sm"
                  title="Habilitar Usuário"
                  v-if="row.item.status === 'Desabilitado'"
                  @click="ativar(row.item)">
                  <i class="fa fa-check"></i>
                </b-button>
                <b-button variant="danger" size="sm"
                  v-if="row.item.status === 'Habilitado'"
                  title="Desabilitar Usuário"
                  @click="desativar(row.item)">
                  <i class="fa fa-minus"></i>
                </b-button>
              </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
    computed: {
      isAdministrador () {
        return this.$store.getters.isAdministrador;
      },
      empresa () {
        return this.$store.getters.empresa;
      },
      fieldsEmpresa() {
        return [
              {key: 'master', label: '', class: 'text-center'},
              {key: 'status'},
              {key: 'name'},
              {key: 'username'},
              {key: 'email'},
              {key: 'telefoneCelular', label: 'Telefone Celular'},
              {key: 'actions'}
          ];
      }
    },
    watch: {
      async empresa() {
        this.loadVendedores();
      }
    },
    async mounted () {
       this.loadVendedores();
    },
    data() {
        return {
            vendedores: [],
            loading: false
        }
    },
    methods: {
      async loadVendedores () {
        this.loading = true;

        const responseVendedores = await axios.get('/api/user?role__nin=clube,DRACHEI&juridica=' + this.empresa._id);
        this.vendedores = responseVendedores.data;
        this.loading = false;
      },
      formVendedor(vendedor) {
        this.$router.push({name: 'EmpresaVendedorForm', query: {id: vendedor._id}})
      },
      async ativar(vendedor) {
        vendedor.status = 'Habilitado';
        await axios.put(`/api/user/${vendedor._id}`, vendedor);
      },
      async desativar(vendedor){
        vendedor.status = 'Desabilitado';
        await axios.put(`/api/user/${vendedor._id}`, vendedor);
      }
    }
}
</script>
<style scoped>
.status-pill.orange{
  background-color: orange;
}
</style>
